var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{class:_vm.FontClass,attrs:{"color":this.ScoutingRatingColor(_vm.score),"rotate":"270","size":_vm.size,"width":_vm.Width,"value":_vm.percentage}},[(_vm.score.valueOf() <= 4.5)?_c('span',[_vm._v(_vm._s(_vm.score.toFixed(2)))]):_c('span',[_vm._v("4+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }